import { render, staticRenderFns } from "./FigureRecipes.vue?vue&type=template&id=17ebf32b&scoped=true&"
import script from "./FigureRecipes.vue?vue&type=script&lang=js&"
export * from "./FigureRecipes.vue?vue&type=script&lang=js&"
import style0 from "./FigureRecipes.vue?vue&type=style&index=0&id=17ebf32b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ebf32b",
  null
  
)

export default component.exports